import NavBar from '@/components/Nav.vue';

import functions from '@/functions.js';

export default {
    name: 'SubscribePage',
    components: {
        NavBar,
    },
    data() {
        return {
            page: 1,
            more: true,
            loading: false,
            data: {},
            priorities: []
        }
    },
    created() {
        this.getProductList();
    },
    mounted() {
        window.addEventListener('scroll', this.scroll, true);
    },
    unmounted() {
        window.removeEventListener('scroll', this.scroll, true);
    },
    methods: {
        getProductList() {
            if (this.more && ! this.loading) {
                this.loading = true;
                this.$http.get('product/subscribe', {params: {page: this.page}}).then(result => {
                    if (result.data) {
                        this.page++;
                        this.loading = false;
                        this.more = result.data.more;
                        result.data.products.forEach(product => {
                            let releaseTime = product.release_time;
                            if (typeof this.data[releaseTime] == 'undefined') {
                                this.data[releaseTime] = {
                                    release_day: functions.dateFormat('mm月dd日', product.release_time),
                                    release_time: functions.dateFormat('HH:ii', product.release_time),
                                    products: []
                                };
                            }
                            product.release_time = functions.dateFormat('YYYY-mm-dd HH:ii:ss', product.release_time);
                            this.data[releaseTime].products.push(product);
                        })
                        this.priorities = this.priorities.concat(result.data.priorities);
                    }
                })
            }
        },
        scroll() {
            let scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
            if (document.documentElement.scrollHeight - scrollTop - document.documentElement.clientHeight <= 100) {
                this.getProductList();
            }
        }
    }
}